import React, { useState } from "react";
import { useForm } from 'react-hook-form';
import { DynamicSelect } from "../../components/DynamicSelect";
import Flex from '@react-css/flex';
import Modal from 'react-modal';
import { StyledForm } from "../../styled-components/StyledForm.style";

export const ModalTimer = ({ 
                              atividade, 
                              atividades,
                              getAtividade,
                              isOpen,
                              onAfterOpen,
                              onRequestClose
                            }) => {
  const { register } = useForm();
  var [descricao, setDescricao] = useState(null);

  const style = {
    content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    borderRadius: "0px",
    minWidth: '35%',
    overflowY: 'auto',
    minHeight: '45%',
    maxHeight: '90%'
    },
        overlay: {
            zIndex: 9999
        }
};

  const handleDescricao = (valor) => {
    descricao = valor;
    setDescricao(descricao);
  }

    return (
      <Modal
          isOpen={isOpen}
          onAfterOpen={onAfterOpen}
          onRequestClose={onRequestClose}
          contentLabel="Timesheet Atividades"
          style={style}
          ariaHideApp={false}
          shouldCloseOnOverlayClick={false}
      >
        <StyledForm>
          <p className="modal-close" onClick={onRequestClose}>X</p>
            </StyledForm>                       
            <Flex>
            <StyledForm>
                    <Flex>
                        <Flex.Item className="modal-width">
                                <div className="position-relative form-group">                  
                                    <p className="modal-title">Tempo de Atividade</p>                                                        
                                </div>
                        </Flex.Item>
                    </Flex>                             
                    <Flex>
                        <Flex.Item className="modal-width">
                            <div style={{ width: '100%'}} className="position-relative form-group">
                                <DynamicSelect required="required" register={register} placeholder={''} valuetext={atividade} label={'Atividade'} name={'idAtividade'} options={atividades} keyValue={'key'} keyLabel={'value'} paramMethod={getAtividade} />                                  
                            </div>
                        </Flex.Item>
                    </Flex>
                    <Flex>
                        <Flex.Item className="modal-width">
                            <div style={{ width: '100%'}} className="position-relative form-group">
                                <textarea rows="3" className="input-form" placeholder='Descrição' name='descricao' onBlur={handleDescricao} />
                            </div>
                        </Flex.Item>
                    </Flex> 
                    <Flex>
                        <Flex.Item className="modal-width">
                                <div className="position-relative form-group modal-align-center">
                                    <input className='default-button-red' value='Timerar' type="button"/>
                                </div>
                        </Flex.Item>
                    </Flex>                                                                                               
                </StyledForm>
              </Flex>                            
      </Modal>
    );
};